/** Hide redundant "Offentlig" for guests — they only see public events anyway. */
export function shouldShowEventVisibilityLabel(
  visibility: string | undefined | null,
  isLoggedIn: boolean
): boolean {
  if (!visibility) {
    return false;
  }
  return isLoggedIn || visibility !== 'public';
}
